module.exports = __webpack_public_path__ + "img/start_linda.3006c0b1.png";